/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.7.0",
  "gitBuildTime": "2026-03-25T17:41:12.544Z",
  "gitBuildVersion": "2.7.0",
  "gitCommitId": "e458369",
  "gitCommitIdFull": "e458369a640d3d97a0e708158313dac18246d7e8",
  "gitCommitTime": "2026-03-25T17:40:00.000Z",
  "version": "2.7.0-2026-03-25T17:40:00.000Z-(e458369)"
};
